import './Footer.css';
import SiteHTML from '../SiteSpecific/SiteSpecific';

const LabFooter = () => {
  return (
    <div className="hs-footer">
      <SiteHTML param="footer" />
    </div>
  );
};

export default LabFooter;
